import React, { useEffect, useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";
import axios from "axios";
import htmlDocx from "html-docx-js/dist/html-docx";

const DownloadScript = ({ resData, goBack, fileName, data }) => {
  console.log("resData5=", resData);
  const [isdesable, setIsDesable] = useState(false);
  const [isCheckingFile, setCheckingFile] = useState(false);

  const [showUploadModal, setShowUploadModal] = useState(false);
  const [file, setFile] = useState(null);
  const [blobData, setBlobData] = useState(null);
  const [jiraKey, setJiraKey] = useState(-1);
  const [loading, setLoading] = useState(true);
  const [uploadFileName, setUploadFileName] = useState("");
  const [showConfirmation, setShowConfirmation] = useState(false);
  //
  //   if (jiraKey != -1) {

  //   const confirmed = window.confirm(
  //     "Are you sure you want to delete this user?"
  //   );
  //   if (!confirmed) {
  //     // console.log(allArticle)
  //     return;
  //   }
  // }
  //
  const downloadFile = async () => {
    try {
      // alert(data.scriptName);
      // return;
      // Convert HTML content into a DOCX blob
      const docxBlob = htmlDocx.asBlob(resData.description);
      const url = URL.createObjectURL(docxBlob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${data.scriptName || data.scriptId || "Job Aid"}.docx`;
      a.click();
      URL.revokeObjectURL(url);
      let name = data.scriptName || data.scriptId || "Job Aid";
      toast.success(`${name} file is downloaded successfully`);
    } catch (error) {
      console.error("Error downloading docx file:", error);
      toast.error("Failed to download job_aid file");
    }
  };
  //
  console.log("fileName=", fileName);

  const checkDublicateTestCase = async (uploadedFile) => {
    try {
      const res = await axios.get(
        `https://kr.camptratech.com/backend_cosmos/jira/search-issues?Test_Case_ID=${uploadedFile}`
      );

      console.log("line44Data=", res.data.key);

      if (res.data.key) {
        setJiraKey(res.data.key);
      }

      setLoading(false);

      // Return the response data
      return res.data;
    } catch (err) {
      console.error(err);
      setLoading(false);

      // Return an error object for the caller to handle
      return { error: true, message: err.message };
    }
  };

  //
  useEffect(() => {
    if (resData.length == 0 || !fileName) {
      setLoading(false);
    } else {
      axios
        .get(
          `https://kr.camptratech.com/backend_cosmos/jira/search-issues?Test_Case_ID=${fileName}`
        )
        .then((res) => {
          console.log("line44Data=", res.data.key);
          if (res.data.key) {
            setJiraKey(res.data.key);
          }
          setLoading(false);
        })
        .catch((err) => {
          // console.log(err);
          setLoading(false);
        });
    }
  }, []);
  const uploadToJira = () => {
    console.log("upload to jira");
    const fromData = new FormData();
    fromData.append("file", resData);
    if (jiraKey != -1) {
      axios
        .put(
          `https://kr.camptratech.com/backend_cosmos/upload-excel/script/${jiraKey}`,
          fromData,
          {
            responseType: "blob",
            headers: { "Content-Type": "multipart/form-data" },
          }
        )
        .then((res) => {
          toast.success("Test case updated successfully");
          setIsDesable(true);
        });
    } else {
      axios
        .post(
          "https://kr.camptratech.com/backend_cosmos/upload-excel/script",
          fromData,
          {
            responseType: "blob",
            headers: { "Content-Type": "multipart/form-data" },
          }
        )
        .then((res) => {
          toast.success("Test case created successfully");
          setIsDesable(true);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const checkDuplicateTestCase = async (uploadedFile) => {
    try {
      setIsDesable(true);
      setCheckingFile(true);
      const res = await axios.get(
        `https://kr.camptratech.com/backend_cosmos/jira/search-issues?Test_Case_ID=${uploadedFile}`
      );
      setIsDesable(false);
      setCheckingFile(false);
      return res.data;
    } catch (err) {
      console.error(err);
      setIsDesable(false);
      setCheckingFile(false);

      return { error: true, message: err.message };
    }
  };

  const handleFileChange = async (e) => {
    setJiraKey(-1);
    const uploadedFile = e.target.files[0];
    console.log(uploadedFile.name);
    // filename

    if (uploadedFile) {
      if (
        uploadedFile.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        setFile(uploadedFile);
        const checkFileRes = await checkDuplicateTestCase(
          uploadedFile.name.replace(/\.xlsx$/, "")
        );
        if (checkFileRes.key) {
          setJiraKey(checkFileRes.key);
          setShowConfirmation(true); // Show confirmation step
        }
      } else {
        toast.error("Please upload a valid .XLSX file.");
      }
    }
  };
  const processFile = async () => {
    if (!file) {
      toast.error("Please select a file before uploading.");
      return;
    }
    // setIsDesable(true);

    const fileBlob = new Blob([file], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const formData = new FormData();
    formData.append("file", fileBlob);
    // alert(jiraKey);
    // return;
    try {
      if (jiraKey !== -1) {
        // Update the existing test case
        setIsDesable(true);
        //setCheckingFile(true);
        await axios.put(
          `https://kr.camptratech.com/backend_cosmos/upload-excel/script/${jiraKey}`,
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
        setIsDesable(false);
        setCheckingFile(false);
        toast.success("Test case updated successfully");
      } else {
        setIsDesable(true);
        // setCheckingFile(true);
        // Create a new test case
        await axios.post(
          "https://kr.camptratech.com/backend_cosmos/upload-excel/script",
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
        toast.success("Test case created successfully");
      }
      setIsDesable(false);
      setCheckingFile(false);
      setShowUploadModal(false);
    } catch (err) {
      setIsDesable(false);
      setCheckingFile(false);
      console.error(err);
      toast.error("Failed to upload.");
    } finally {
      setIsDesable(false);
      setCheckingFile(false);
      setIsDesable(false);
    }
  };

  const handleClose = () => {
    setShowUploadModal(false);
    setIsDesable(false);
    setFile(null);
    setJiraKey(-1);
    setShowConfirmation(false);
  };
  return (
    <div>
      <div>
        {/*  */}

        <div
          className="pt-5"
          dangerouslySetInnerHTML={{ __html: resData.description }}
        />

        {/*  */}

        <Modal
          backdrop="static"
          show={showUploadModal}
          onHide={handleClose}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {showConfirmation ? "Confirm Update" : "Upload .XLXS File"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {showConfirmation ? (
              <div>
                <p>
                  This test case already exists with ID{" "}
                  <strong>{jiraKey}</strong>. Do you want to update it?
                </p>
                <div className="d-flex justify-content-end">
                  <Button
                    variant="secondary"
                    onClick={() => {
                      setShowConfirmation(false);
                      setFile(null);
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="primary"
                    onClick={processFile}
                    disabled={isdesable}
                  >
                    {isdesable ? "Updating..." : "Yes, Update"}
                  </Button>
                </div>
              </div>
            ) : (
              <input
                type="file"
                className="form-control"
                accept=".xlsx"
                onChange={handleFileChange}
              />
            )}
          </Modal.Body>
          {!showConfirmation && (
            <Modal.Footer>
              <Button
                disabled={!file || isdesable}
                onClick={processFile}
                className="w-100"
              >
                {isCheckingFile
                  ? "Checking file existence..."
                  : isdesable
                  ? "Uploading..."
                  : "Upload"}
              </Button>
            </Modal.Footer>
          )}
        </Modal>
      </div>
      {loading ? (
        <div className="text-center pt-5 mt-5">
          <Spinner />:
        </div>
      ) : (
        <div>
          <div className="d-none">
            <h4 className="text-center pt-5">
              Generate your next test script with our GenAI technology
            </h4>
            {/* <p className="fw-bolder  pt-5">
            Test Script: Oracle General Ledger - Create Post Journal Entry
          </p>
          <p className="fw-bolder pt-2">Test Objective</p>
          <p>
            To validate the process of creating and posting a journal entry in
            oracle General ledger
          </p> */}
            {resData.length == 0 ? (
              ""
            ) : (
              <p className="fw-bolder pt-1  pt-5 text-center">
                File name: {fileName == "" ? "SampleFile" : fileName}.xlsx
              </p>
            )}
          </div>
          {/* {resData.length == 0 ? (
            <div className="text-center pt-4">
              <Button onClick={() => setShowUploadModal(true)}>
                upload To Jira
              </Button>
            
              <Button onClick={() => goBack()}>New Script</Button>
            </div>
          ) : (
            <div className="text-center">
              <Button onClick={downloadFile}>Download</Button>
              
              <Button onClick={() => setShowUploadModal(true)}>
                upload To Jira
              </Button>
              <Button onClick={() => goBack()}>New Script</Button>
            </div>
          )} */}
          <div className="text-center py-4">
            <Button onClick={() => goBack()}>New Job Aid</Button>
            <Button onClick={downloadFile}>Download</Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default DownloadScript;
